<style lang="scss" scoped>
.scroller {
  height: 100%;
  overflow-y: scroll;
}

.date-header {
  background-color: #dae3f0;
}
</style>

<template>
  <div class="flex-grow-1 pb-5 scroller" ref="scroller">
    <div v-if="canLoadMoreMessages && !mirror" class="p-3">
      <v-button
        @click.native="loadDialog(true)"
        type="button"
        class="mx-auto d-block"
        :working="loading"
      >
        Ältere Nachrichten laden
      </v-button>
    </div>
    <div v-for="(messages, date) in groupedMessages" :key="date">
      <div class="d-flex justify-content-center my-3">
        <span class="p-2 rounded date-header">{{ getDateText(date) }}</span>
      </div>
      <dialog-message
        v-for="message in messages"
        :profile="profileModel"
        :key="message.id"
        :message="message"
        :moderation="moderator"
      ></dialog-message>
    </div>
    <div v-if="canLoadMoreMessages && mirror" class="p-3">
      <v-button
        @click.native="loadDialog(true)"
        type="button"
        class="mx-auto d-block"
        :working="loading"
      >
        Ältere Nachrichten laden
      </v-button>
    </div>
  </div>
</template>

<script lang="babel">
import DialogMessage from "@/components/DialogMessage.vue";
import moment from "moment";

export default {
  components: {
    DialogMessage
  },
  props: {
    idPartner: {
      required: true,
    },
    idProfile: {
      type: Number,
      default: null
    },
    profile: {
      type: Object,
    },
    moderator: {
      type: Boolean,
      default: false
    },
    mirror: {
      type: Boolean,
      default: false
    },
    infiniteScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      bottom: false
    };
  },
  computed: {
    authCustomerProfileId() {
      let customerProfile = this.$store.getters["user/authCustomerProfile"];

      return customerProfile ? customerProfile.id : null;
    },
    messages () {
      let messages = this.$store.getters["message/dialog"](this.idPartner, this.profileId);

      if (this.mirror) return messages.reverse();
      else {return messages;}
    },
    groupedMessages() {
      return this.messages.reduce((result, message) => {
          let date = moment(message.created_at).format("DD.MM.YYYY");
          if (!result[date]) {
            result[date] = [];
          }
          result[date].push(message);
          return result;
        }, {});
    },
    showLoading() {
      return this.loading && (!this.messages || this.messages.length === 0)
    },
    canLoadMoreMessages() {
      return this.messages.length < this.$store.getters["message/getDialog"](this.idPartner, this.profileId).count;
    },
    profileId() {
      return this.idProfile ? this.idProfile : this.profile.id;
    },
    profileModel() {
      if (this.profile) {
        return this.profile;
      }
      return this.messages[0].sender_id === this.idProfile ? this.messages[0].sender : this.messages[0].receiver;
    },
  },
  created() {
    this.loadDialog(false);

    this.$bus.$on('loaded-image', () => {
      this.scrollTo();
    });

    this.$bus.$on('new-message', (messages) => {

      if (!Array.isArray(messages) || messages.length === 0) {
        return;
      }

      if (!messages || messages[0].receiver_id === this.idPartner || messages[0].sender_id === this.idPartner) {
        if (this.profileId === this.authCustomerProfileId && messages) {
          let messageIds = messages.reduce((messageIds, message) => {
            if (message.receiver_id === this.profileId && message.read_at === null) {
              messageIds.push(message.id);
            }
            return messageIds;
          }, []);

          if  (messageIds.length > 0) {
            this.$store.dispatch("message/readAt", messageIds);
          }
        }
        this.scrollTo();
      }
    });
  },
  destroyed() {
    this.$bus.$off('new-message');
  },
  beforeDestroy() {
    this.$store.commit("message/resetSkip", { id: this.idPartner + '-' + this.profileId });
  },
  methods: {
    scrollTo() {
      this.$nextTick(() => {
        if (this.$refs.scroller) {
          if(this.mirror)
            this.$refs.scroller.scrollTop = 0;
          else
            this.$refs.scroller.scrollTop = this.$refs.scroller.scrollHeight;
        }
      })
    },
    loadDialog(shouldSkip) {
      this.loading = true;
      this.$emit('loading', true);

      this.$store.dispatch('message/dialog', {
        id1: this.idPartner,
        id2: this.profileId,
        shouldSkip: shouldSkip
      }).finally(() => {
        this.loading = false;
        this.$emit('loading', false);
      });
    },
    getDateText(dateString) {
      if (moment().isSame(moment(dateString, "DD.MM.YYYY"), 'day')) {
        return "Heute";
      }

      if (moment().subtract(1, 'days').isSame(moment(dateString, "DD.MM.YYYY"), 'day')) {
        return "Gestern";
      }

      return dateString;
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight - 100;
      return bottomOfPage || pageHeight < visible;
    }
  },
  mounted() {
    if (this.infiniteScroll) {
      window.addEventListener("scroll", () => {
        this.bottom = this.bottomVisible();
      });
      this.loadDialog(true);
    }
  },
  watch: {
    idPartner() {
      this.scrollTo();
      this.loadDialog();
    },
    bottom(bottom) {
      if (bottom && !this.loading && this.infiniteScroll) this.loadDialog(true);
    }
  }
}
</script>
